// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5108) return "static/chunks/5108.8c69cdca8b7345ae.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"7523":"45e8aa61ad14d27b","8829":"51ef92042c266edf"}[chunkId] + ".js";
};